import WelcomeIcon from './WelcomeIcon';

export default WelcomeIcon;
